var types = {
  PAGE: 'page',
  COMPONENT: 'component'
};
export default types;